import "./login.css";
import { LoginCard } from "components/pages/Home/LoginCard";
import logo from "assets/OKO_Core_Logotype2.svg";
import okoWelcome from "assets/oko-welcome.svg";
import loginBlob from "assets/login_blob.png";
import { generateRouteUrl } from "utils/generateRoutePath";
import { colors, constants } from "utils";
import { Button } from "react-bootstrap";
import styled from "styled-components";
import { SignInButton } from "components/shared/SignInButton/SignInButton";

const ADMIN_PATH_PREFIX = "/admin/";

const getSafeAdminNextPath = () => {
  const nextPath = new URLSearchParams(window.location.search).get("next");
  if (!nextPath?.startsWith(ADMIN_PATH_PREFIX)) {
    return null;
  }
  const { pathname } = new URL(nextPath, window.location.origin);
  const isAdminPage = pathname.startsWith(ADMIN_PATH_PREFIX) && pathname !== constants.ADMIN_LOGIN_PATH;
  return isAdminPage ? nextPath : null;
};

export const Login = ({ redirectPath, redirectParams, isSignUp, authOptions, pathName, returnToAdminNext }) => {

  const isEducatorLoginPath = constants.EDUCATOR_LOGIN_ROUTE_NAME === pathName

  const getRedirectUri = () => {
    const nextPath = returnToAdminNext && getSafeAdminNextPath();
    if (nextPath) {
      return `${window.location.origin}${nextPath}`;
    }
    if (redirectPath) {
      return generateRouteUrl(redirectPath, redirectParams);
    }
    return window.location.origin;
  };

  return (
    <Container isEducatorLogin={isEducatorLoginPath}>
      {
        isEducatorLoginPath ? (
          <>
            <BlobBackground src={loginBlob} alt="" />
            <LoginCard borderRadius={1}>
              <Wrapper gap={'1.5rem'}>
                <a href={constants.OKO_WEBSITE_URL} aria-label="OKO website">
                  <Image src={okoWelcome} alt="logo" />
                </a>

                <SignOptionsContainer>
                  <Text>Teacher Login</Text>
                  {authOptions?.includes(constants.GOOGLE) && <SignInButton providerOption="google" redirectUri={getRedirectUri()} isEducator />}
                  {authOptions?.includes(constants.CLEVER) && <SignInButton providerOption="clever" redirectUri={getRedirectUri()} />}
                  {authOptions?.includes(constants.CLASSLINK) && <SignInButton providerOption="classlink" redirectUri={getRedirectUri()} />}
                  {authOptions?.includes(constants.MICROSOFT) && <SignInButton providerOption="microsoft" redirectUri={getRedirectUri()} isEducator />}
                </SignOptionsContainer>
                <Divider />
                <ButtonContent>
                  <Text>Students, ready to join your team?</Text>
                  <StudentButton href="/" target="_blank">
                    <Text fontSize={1}>Enter group code</Text>
                  </StudentButton>
                </ButtonContent>
              </Wrapper>
            </LoginCard>
          </>
        ) : (
          <>
            <div className="login-decoration login-decoration-portrait" />
            <LoginCard>
              <Wrapper>
                <Image src={logo} alt="logo" />
                {isSignUp && <p style={{ fontSize: "24px" }}>Educator Sign Up</p>}
                {isSignUp && <p style={{ fontSize: "18px" }}>
                  We're excited for your students to start using OKO!
                </p>}
                <SignOptionsContainer>
                  {authOptions?.includes(constants.GOOGLE) && <SignInButton providerOption="google" redirectUri={getRedirectUri()} isEducator isSignUp={isSignUp} />}
                  {authOptions?.includes(constants.CLEVER) && <SignInButton providerOption="clever" redirectUri={getRedirectUri()} isEducator isSignUp={isSignUp} />}
                  {authOptions?.includes(constants.CLASSLINK) && <SignInButton providerOption="classlink" redirectUri={getRedirectUri()} isEducator isSignUp={isSignUp} />}
                  {authOptions?.includes(constants.MICROSOFT) && <SignInButton providerOption="microsoft" redirectUri={getRedirectUri()} isEducator isSignUp={isSignUp} />}
                </SignOptionsContainer>
              </Wrapper>
            </LoginCard>
          </>
        )
      }
    </Container >
  );
};

const SignOptionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  align-items: center;
`

export const Image = styled.img`
  width: 196px;
`

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: ${({ gap }) => gap ?? '2rem'};
  padding: 2rem;
  text-align: center;
`

export const ButtonContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: .5rem;
  align-items: center;
`

export const Text = styled.p`
  font-family: Roboto;
  font-weight: 700;
  font-style: Bold;
  font-size: ${({ fontSize }) => fontSize ?? 0.875}rem;
  line-height: 100%;
  text-align: center;
`

export const StudentButton = styled(Button)`
  background-color: ${colors.blue500};
  width: 198.5px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background-color: ${colors.blue500};
  }
`

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  width: 100vw;
  position: relative;
  overflow: hidden;
  background-color: ${({ isEducatorLogin }) => isEducatorLogin ? '#605DEC' : 'transparent'};
`

const BlobBackground = styled.img`
  position: absolute;
  width: 700px;
  max-width: 90vw;
  height: auto;
  pointer-events: none;
  user-select: none;
  z-index: 0;
`

export const Divider = styled.hr`
  width: 100%;
  max-width: 96px;
  border-top: 2px solid #CBCDCC;
  margin: 0;
`

